"use strict";
import React from "react";
import FormsyFields from "./formsyFields"
import classNames from 'classnames';

class StyledRadio extends React.Component {

	static defaultProps = {
		label: '',
		rowLabel: '',
		value: false,
		onChange: () => { }
	}

	changeValue(event) {
		const target = event.currentTarget;
		this.props.onSetValue(target.checked);
		this.props.onChange(this.props.name, target.checked);
	}

	render() {
		const {
            isPristine, layout, help, elementWrapperClassName, labelClassName,
            rowClassName, errorMessages, showErrors, onSetValue, rowLabel, ...restProps
        } = this.props;
		const wrapperClassNames = classNames('radio-group', elementWrapperClassName);
		const labelClassNames = classNames(labelClassName);

		return (
			<div className={wrapperClassNames}>
				<input
					{...restProps}
					type="radio"
					id={this.props.id}
					checked={this.props.value === true}
					disabled={this.props.disabled}
					onChange={this.changeValue.bind(this)}
				/>
				<label htmlFor={this.props.id} className={labelClassNames}>{this.props.label}</label>
			</div>
		);
	}
}

module.exports = FormsyFields.FormsyReactComponent(StyledRadio);